// Shared config for prompt node types — used by PromptNode.jsx and NodeProperties.jsx
export const PROMPT_TYPE_COLORS = {
  base: '#3a7a3a',
  global: '#78909c',
  vendor: '#7a5a20',
  country: '#6a3a7a',
};

export const PROMPT_TYPE_LABELS = {
  base: 'BASE',
  global: 'GLOBAL',
  vendor: 'VENDOR',
  country: 'REGION',
};

export const PROMPT_TYPES = ['base', 'global', 'vendor', 'country'];

export const SLOT_COLOR = '#0891b2';
export const SLOT_ICON = '{{ }}';
